import { useState } from "react";
import { CardBody, Tooltip, Card } from "reactstrap";

const StorageCard = ({
  title,
  value = 0,
  percent = 0, 
  tooltipText,
  iconClass,
  bgColor,
  iconColor,
  percentLabel
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

  const tooltipId = `tooltip-${title?.replace(/\s+/g, "-").toLowerCase()}`;

  return (
    <Card
      className="avg-unique-call card-animate"
      style={{
        padding: "0.5rem",
        fontSize: "0.875rem",
        height: "75px",
        borderRadius: "8px",
        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
      }}
    >
      <CardBody className="p-2">
        <div className="d-flex align-items-center">
          <div className="avatar-sm flex-shrink-0">
            <span
              className="avatar-title rounded-circle"
              style={{
                backgroundColor: bgColor,
                width: "35px",
                height: "35px",
                fontSize: "1.5rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <i className={iconClass} style={{ color: iconColor }}></i>
            </span>
          </div>
          <div className="flex-grow-1 ms-2">
            <p
              className="text-capitalize mb-1"
              style={{
                fontWeight: "700",
                fontSize: "0.75rem",
                marginBottom: "4px",
              }}
            >
              {title}
            </p>
            <div className="d-flex justify-content-between align-items-center">
              <h5
                className="mb-0 fw-bold"
                style={{
                  fontSize: "0.875rem",
                  lineHeight: "1.2",
                }}
              >
                {value} 
              </h5>
              <span className="text-secondary fw-bold me-5" style={{ fontSize: "0.775rem" }}>
               {percent} % {percentLabel} 
              </span>
            </div>
            <div>
              <div
                id={tooltipId}
                className="dashboard-tooltip-eyes"
                style={{
                  display: "inline-block",
                  marginLeft: "5px",
                  cursor: "pointer",
                }}
              >
                <span className="ri-information-line"></span>
              </div>

              <Tooltip
                placement="top"
                isOpen={tooltipOpen}
                toggle={toggleTooltip}
                target={tooltipId}
              >
                {tooltipText}
              </Tooltip>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default StorageCard;
